import type { JSX } from 'react'
import { useLocation } from 'react-router-dom'

import { ProchaineAction } from '@/components/ProchaineAction'
import { useWorkspace } from '@/hooks/useWorkspace'
import { niveauDuChemin } from '@/lib/nav'

/** N28 au niveau Projet seulement, à droite du fil d'Ariane (§ 4.3.1) ; au téléphone, voir
 *  BandeTelephone (pastille en tête du contenu). */
export function ProchaineActionProjet(): JSX.Element | null {
  const { pathname, search } = useLocation()
  const { activeId } = useWorkspace()
  if (niveauDuChemin(pathname, search) !== 'projet' || !activeId) return null
  return <ProchaineAction workspaceId={activeId} />
}
